export default {
  titleOne: 'Who We Are?',
  contentOne: `We are a Sino-Canadian joint venture professional control valve manufacturer, and have been engaged in the field of industrial control for 60 years`,
  historyForSummarize: {
    bgImgSrc: require('@/assets/images/home/history_for_summarize_bg.jpg'),
    children: [
      {
        title: 'Satisfied customers',
        subTitle: '860+',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon01.png'),
      },
      {
        title: 'Completed projects',
        subTitle: '960',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon02.png'),
      },
      {
        title: 'Good feedback',
        subTitle: '99%',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon03.png'),
      },
      {
        title: 'Unit quantity',
        subTitle: '80000+',
        iconSrc: require('@/assets/images/home/history_for_summarize_icon04.png'),
      }
    ]
  },
  aboutList: [
    {
      imgsrc: require("@/assets/images1/index/img1.png"),
      name: "We Design Valves",
      introductior: "Wuxi KELK (KELK) design department is committed to the design of high quality, high reliability, high safety valve products. We use advanced software to forward design and reverse engineer our products",
    },
    {
      imgsrc: require("@/assets/images1/index/img2.png"),
      name: "We Manufacture Valves",
      introductior: "Wuxi KELK has been committed to importing key components (such as fillers and springs) to produce products with quality close to the original and price close to the domestic high performance price ratio",
    },
    {
      imgsrc: require("@/assets/images1/index/img3.png"),
      name: "We Repair Valves",
      introductior: "Wuxi KELK (KELK) has a professional valve after-sales, maintenance and overhaul team, to undertake all kinds of valve maintenance and overhaul projects, greatly improving the added value of products",
    },
  ],
  /* aboutList: [
    {
      imgsrc: require("@/assets/images1/index/img1.png"),
      name: "Trinity design system",
      introductior: `
      Wuxi Kelke uses the "reliability pyramid" model to drive research and development, integrates CFD fluid simulation / 3D laser mapping technology, and creates nuclear power grade safety valves through API 6D/ASME certification standards
      `,
    },
    {
      imgsrc: require("@/assets/images1/index/img2.png"),
      name: "Global supply chain collaborative intelligence",
      introductior: `
      Using imported core components such as German high-elastic sealing filler and Japanese precision spring, combined with modular patented technology, we achieve a core product matrix with performance comparable to imports and cost optimization of 30%
      `,
    },
    {
      imgsrc: require("@/assets/images1/index/img3.png"),
      name: "Full life cycle service ecology",
      introductior: `
      Equipped with CNAS certified laboratory and a team of 100 experts, we provide intelligent diagnosis/core component regeneration services, and the annual regeneration and repair rate of imported equipment exceeds 95%, reshaping the industrial equipment value chain
      `,
    },
  ], */
  titleTwo: 'Our Industry',
  // contentTwo: 'Wuxi Kelke has been providing and maintaining equipment for oil and gas, petrochemical and chemical industry, fine chemical industry, metallurgy and nonferrous metal, industrial gas, energy and environmental protection, electric drive and other industrial control fields and instrumentation industries for more than 60 years, especially control valves and control equipment with high technical content and customer support services. These areas have very high requirements for valves',
  // titleTwo: 'KELK is a multi-domain fluid expert',
  contentTwo: `
  <div style="text-align:justify;text-align-last: center;">
    In the field of petroleum refining, clean energy, metallurgy and other harsh working conditions for 60 years, Wuxi Kelke defines industrial safety and efficiency benchmarks with ultra-low temperature cryogenics valves, power station main steam control valves and other cutting-edge fluid control products. From LNG supercritical storage and transportation to hydrogen energy ultra-high pressure control, from intelligent metallurgical blast furnaces to environmental protection desulphurization devices, we customize and develop various standard high-end control equipment and full life cycle management services for global industrial giants with 18 patented technologies such as multi-stage depressive-labyrinth valve core and metal bellows dynamic seal, reshaping industrial flow control standards with Chinese precision
  </div>
  `,
  titleThree: 'Our Ability',
  contentThree: '',
  abilityList: [
    {
      imgsrc: require("@/assets/images1/icon1.png"),
      name: "Engineering Design",
      // english: "Advanced Technology",
      english: "",
      id: 1,
    },
    {
      imgsrc: require("@/assets/images1/icon2.png"),
      name: "Machining and Welding",
      // english: "Excellent Management",
      english: "",
      id: 2,
    },
    {
      imgsrc: require("@/assets/images1/icon3.png"),
      name: "Production Casting",
      // english: "Perfect Manufacturing",
      english: "",
      id: 3,
    },
    {
      imgsrc: require("@/assets/images1/icon4.png"),
      name: "Supply Management",
      // english: "Reliable Quality",
      english: "",
      id: 4,
    },
  ],
  titleFour: 'Our News',
  contentFour: '',
  titleFive: 'Our Story',
  contentFive: '',
  titleSix: 'Our Customers',
  contentSix: '',
  // 悬浮公告弹框
  bannerPopup: {
    title: 'Bulletin board',
    linkText: 'Click to go',
  }
}


// WEBPACK FOOTER //
// ./src/config/lang/en/homePage.js